module.exports = __webpack_public_path__ + "media/newstyle/images/card-icon-4-9985d1a56d65961bbbb45e4742effc9d.svg";